import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'

export const sendOpenChatbotEvent = (): void => {
	sendGenericEvent('open_chatbot')
}
